import { render, staticRenderFns } from "./deleteModal.vue?vue&type=template&id=97d3976e&scoped=true&"
import script from "./deleteModal.vue?vue&type=script&lang=js&"
export * from "./deleteModal.vue?vue&type=script&lang=js&"
import style0 from "./deleteModal.vue?vue&type=style&index=0&id=97d3976e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d3976e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97d3976e')) {
      api.createRecord('97d3976e', component.options)
    } else {
      api.reload('97d3976e', component.options)
    }
    module.hot.accept("./deleteModal.vue?vue&type=template&id=97d3976e&scoped=true&", function () {
      api.rerender('97d3976e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modals/deleteModal.vue"
export default component.exports